
import { useAdminUsers } from "@/hooks/useAdminUsers";
import { AdminUserTable } from "./AdminUserTable";

export const AdminTab = () => {
  const {
    adminUsers,
    loading,
    searchQuery,
    handleSearchChange,
    page,
    pageSize,
    totalCount,
    handlePageChange,
  } = useAdminUsers();

  return (
    <div className="w-full">
      <h3 className="text-lg font-medium mb-4">Admin Users</h3>
      <AdminUserTable
        adminUsers={adminUsers}
        loading={loading}
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
        page={page}
        pageSize={pageSize}
        totalCount={totalCount}
        onPageChange={handlePageChange}
      />
    </div>
  );
};
